/**
 * @author Stefan Lamm <stefan.lamm@pluswerk.ag> Pluswerk AG
 * @type {{Controller: {NewsController: Pluswerk.MesseNewsroom.Controller.NewsController}}}
 */
Pluswerk.MesseNewsroom = {
  variables: {
    eventsToFetch: 0,
    eventsFetched: 0,
    eventErrors: 0,
    locale: {
      en: {
        pressrelease: 'pressrelease',
        exhibitor: 'exhibitor',
      },
      de: {
        pressrelease: 'pressemitteilung',
        exhibitor: 'aussteller',
      }
    },
    urls: {
      baseUrl: 'https://mkdb2.messe-stuttgart.de/api',
      pressreleaseListUrl: '/pm/v1.0/public/pressreleases/',
      exhibitorNewsListUrl: '/pm/v1.0/public/exhibitor-news/',
      pressreleaseDetailUrl: '/pm/v1.0/public/pressrelease/',
      exhibitorNewsDetailUrl: '/pm/v1.0/public/exhibitor-news-detail/'
    },
  },
  functions: {
    formatDate: function (date) {
      var month = '' + (date.getMonth() + 1);
      var day = '' + date.getDate();
      var year = date.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [day, month, year].join('.');
    },
    getLocalizedLabel: function (key, isoCode) {
      var locale = Pluswerk.MesseNewsroom.variables.locale;
      if (locale[isoCode] && typeof locale[isoCode][key] === 'string') {
        return locale[isoCode][key];
      }

      if (typeof locale.en[key] === 'string') {
        return locale.en[key];
      }

      return '';
    }
  },
  Controller: {
    scrollToJsNewsroom: function () {
      var pos = $('.js-newsroom').offset().top - 72;
      if (pos < 0) {
        pos = 0;
      }

      $('html, body').animate({
        scrollTop: pos,
      }, 250);
    },
    NewsController: function ($newsroom) {
      var mkdbUrl = $newsroom.data('mkdb-url');
      if (typeof mkdbUrl !== 'undefined' && mkdbUrl !== '') {
        Pluswerk.MesseNewsroom.variables.urls.baseUrl = mkdbUrl;
      }

      /**
       * properties:
       *   string defaultLanguage (default selected in filter selectbox)
       *   string iAm (latest/list)
       *   int latestLimit (how many news to show in latest-view)
       * @type {*}
       */
      var setUpList = function () {
        var configuration = $newsroom.data('configuration');
        var $filterErrorMessage = $newsroom.find('.js-filter-no-results');
        $filterErrorMessage.text(configuration.labels.empty);
        // create filters
        var newsElements = $newsroom.find('ul:first > li'); // $('.js-newsroom > li');
        if (newsElements.length) {
          $newsroom.find('.js-newsFilter').removeClass('hide');

          // get actual language from hash or default language
          var fromHash = function (get) {
            var hash = location.hash;
            if (hash.length) {
              var pieces = hash.split('-');
              if (get === 'language') {
                return pieces[0];
              } else if (get === 'category') {
                if (pieces.length > 1) {
                  return pieces[1];
                }
                return '';
              } else if (get === 'page') {
                if (pieces.length > 2) {
                  return pieces[2];
                }
                return 1;
              }
              return '';
            }
            return '';
          };

          var langselect = $newsroom.find('.js-newsroom-langselect'),
            catselect = $newsroom.find('.js-newsroom-catselect');

          var getLanguage = function () {
            return langselect.find('option:selected').val();
          };

          // get actual category from hash or nothing
          var getCategory = function () {
            var actualSelectedCategory = catselect.find('option:selected').val();
            if (!actualSelectedCategory) {
              actualSelectedCategory = fromHash('category');
            }
            return actualSelectedCategory;
          };

          if (langselect.length && catselect.length) {
            var langselectElement = document.createElement('select');
            langselectElement.setAttribute('class', 'SingleSelect form-control');
            langselectElement.setAttribute('aria-label', 'Language');
            var catselectElement = document.createElement('select');
            catselectElement.setAttribute('class', 'SingleSelect form-control');
            catselectElement.setAttribute('aria-label', 'Type');

            // get all possible options.
            var langs = [],
              cats = [];
            $.each(newsElements, function (index, newsElement) {
              var $newsElement = $(newsElement);
              var filterProperties = $newsElement.data('filter');

              if (langs.indexOf(filterProperties.language) === -1) {
                langs.push(filterProperties.language);
              }

              for (var i = 0; i < filterProperties.categories.length; i++) {
                if (filterProperties.categories[i]) {
                  if (cats.indexOf(filterProperties.categories[i]) === -1) {
                    cats.push(filterProperties.categories[i]);
                  }

                }
              }
            });

            langs.sort();
            cats.sort();
          }

          var urlEncode = function (text) {
            if (!text) return '';
            return text.replace(/[^0-9a-z]/gi, '');
          };

          var setHash = function (which, value) {
            var newhash = '';
            if (which === 'language') {
              newhash = value;

              if (getCategory()) {
                newhash += '-' + getCategory();
              }
            } else if (which === 'category') {
              newhash = getLanguage();
              if (newhash === '') {
                newhash = urlEncode(langs[0]);
              }
              newhash += '-' + value;
            } else if (which === 'page') {
              // set the language
              newhash = getLanguage();
              if (newhash === '') {
                newhash = urlEncode(langs[0]);
              }
              var category = getCategory();
              if (category === '') {
                category = urlEncode(configuration.labels.allTypes);
              }
              newhash += '-' + category + '-' + value;
            }
            location.hash = newhash;
          };

          var actualFilterDefaultLanguageText = configuration.labels.allLanguages;
          langs.unshift(configuration.labels.allLanguages);
          var val;
          var actualFilterLanguage = urlEncode(fromHash('language')); // todo same as category see bottom
          for (var i = 0; i < langs.length; i++) {
            var langOption = document.createElement('OPTION');
            val = urlEncode(langs[i]);
            if (val == '') {
              val = langs[i];
            }
            if (val === actualFilterLanguage) {
              langOption.selected = true;
            }
            langOption.value = val;
            langOption.text = langs[i];

            // do it once on pageload - set the default language as selected on the page
            // Change: do not set the hash for this setting
            if (!location.hash && val === configuration.defaultLanguage) {
              //setHash('language', configuration.defaultLanguage);
              langOption.selected = true;
            }
            langselectElement.add(langOption);
          }

          var actualFilterDefaultCategoryText = configuration.labels.allTypes;
          cats.unshift(configuration.labels.allTypes);
          var actualFilterCategory = urlEncode(fromHash('category')); // TODO no need for encode is encoded but not from languaage[0] see top
          for (var j = 0; j < cats.length; j++) {
            var catOption = document.createElement('OPTION');
            val = urlEncode(cats[j]);
            if (val === actualFilterCategory) {
              catOption.selected = true;
            }
            catOption.value = val;
            catOption.text = cats[j];
            catselectElement.add(catOption);
          }

          // append filters to html
          langselect.append(langselectElement);
          catselect.append(catselectElement);

          /**
           * newsElement.data has fields: category, language
           */
          var shouldWeshowThisElementByFilter = function ($newsElement) {
            var actualFilterCategoryText = $(catselectElement).find('option:selected').text(),
              actualFilterLanguageText = $(langselectElement).find('option:selected').text();
            return (actualFilterDefaultLanguageText === actualFilterLanguageText || actualFilterLanguageText === $newsElement.data('filter').language)
              && (actualFilterDefaultCategoryText === actualFilterCategoryText || $newsElement.data('filter').categories.indexOf(actualFilterCategoryText) !== -1);
          };

          // filter actual news by filter
          var filterNewsByActualFilters = function () {
            var actualCategoryFilterSelectedText = catselect.find('option:selected').text();
            var showing = 0;

            // set selected filters by hash
            for (var k = 0; k < newsElements.length; k++) {
              var $newsElement = $(newsElements[k]);
              if (shouldWeshowThisElementByFilter($newsElement)) {
                showing++;
                // max display for latest...
                if (configuration.iAm === 'latest') {
                  if (showing > configuration.latestLimit) {
                    $newsElement.hide();
                    continue;
                  }
                }

                var filterCategories = $newsElement.data('filter').categories;
                for (var filterCategoriesIterator = 0; filterCategoriesIterator < filterCategories.length; filterCategoriesIterator++) {
                  if (filterCategories[filterCategoriesIterator] === actualCategoryFilterSelectedText) {
                    filterCategories.unshift(filterCategories.splice(filterCategoriesIterator, 1)[0]);
                    break;
                  }
                }

                var newsinfoTypeSpan = $newsElement.find('.js-newsinfo-type');
                var newsinfoType = filterCategories.join(', ');
                if (newsinfoType.length > 33) {
                  newsinfoTypeSpan.attr('title', newsinfoType);
                  newsinfoType = newsinfoType.substr(0, 33) + ' ...';
                }
                newsinfoTypeSpan.html(newsinfoType);
                $newsElement.show();
              } else {
                $newsElement.hide();
              }
            }

            if (newsElements.children(':visible').length === 0 && showing === 0) {
              $filterErrorMessage.removeClass('hide');
            } else {
              $filterErrorMessage.addClass('hide');
            }

            // after all news have been filtered, paginate if we are the list view
            if (configuration.iAm === 'list') {
              var nFormat = '';

              // they go on one page, no pager needed
              if (showing < 19) {
                $newsroom.find('.js-pagination').hide();
                return;
              }

              var pages = showing / 18;

              $newsroom.find('.js-pagination').removeClass('hide').show();

              // the pages range
              for (var y = 0; y < pages; y++) {
                nFormat += 'n';
              }

              $newsroom.find('.js-pagination').paging(showing, {
                format: '< ' + nFormat + ' >', // define how the navigation should look like and in which order onFormat() get's called
                perpage: 18,
                lapping: 0,
                page: fromHash('page'), // start at page, can also be "null" or negative
                onSelect: function (page) {
                  setHash('page', page);
                  // add code which gets executed when user selects a page, how about $.ajax() or $(...).slice()?
                  // this.slice 0 to 18 is the number of elements to show, add the page to hash, load page from hash. do it
                  var virualShow = 0;
                  for (var k = 0; k < newsElements.length; k++) {
                    var $newsElement = $(newsElements[k]);

                    // check show or not show, if show and is in slice range, show, if not, hide (always by filter!!!)
                    if (shouldWeshowThisElementByFilter($newsElement)) {
                      virualShow++;
                      if (virualShow > this.slice[0] && virualShow < this.slice[1] + 1) {
                        $newsElement.show();
                      } else {
                        $newsElement.hide();
                      }
                    }
                  }
                },
                onFormat: function (type) {
                  switch (type) {
                    case 'block': // n and c
                      var current = '';
                      if (this.value === this.page) {
                        current = ' class="current"';
                      }
                      return '<li' + current + '><a onclick="Pluswerk.MesseNewsroom.Controller.scrollToJsNewsroom();" href="#">' + this.value + '</a></li>';
                    case 'next': // >
                      if (this.page > parseInt(pages) || pages - this.page === 0) {
                        return '';
                      }
                      return '<li class="next"><a rel="next" onclick="Pluswerk.MesseNewsroom.Controller.scrollToJsNewsroom();" href="#">' + configuration.labels.next + '</a></li>';
                    case 'prev': // <
                      if (this.page === 1) {
                        return '';
                      }
                      return '<li class="previous"><a rel="prev" onclick="Pluswerk.MesseNewsroom.Controller.scrollToJsNewsroom();" href="#">' + configuration.labels.previous + '</a></li>';
                    case 'first': // [
                      return '<a href="#">first</a>';
                    case 'last': // ]
                      return '<a href="#">last</a>';
                  }
                },
              });
            }
          };

          langselectElement.onchange = function () {
            setHash('language', $(this).val());
            filterNewsByActualFilters();
          };

          catselectElement.onchange = function () {
            setHash('category', $(this).val());
            filterNewsByActualFilters();
          };

          filterNewsByActualFilters();
        }
        // TODO nice to have: may assign img src to prevent old browsers from downloading too much information
      };

      if ($newsroom.data('newsFromMkdb')) {
        $newsroom.find('.js-pagination').addClass('hide');
        var fairEventString = $newsroom.data('event-uids-from-mkdb');
        var exhibitorEventString = $newsroom.data('mkdb-exhibitor-news');

        if (typeof fairEventString === 'undefined' || fairEventString === '') {
          setUpList();
          $newsroom.find('.spinner').addClass('hide');
          return;
        }

        var fairEvents = [];
        if (typeof fairEventString === 'string') {
          if (fairEventString !== '') {
            fairEvents = fairEventString.split(',');
          }
        } else {
          fairEvents = [fairEventString];
        }

        var exhibitorEvents = [];
        if (typeof exhibitorEventString === 'string') {
          if (exhibitorEventString !== '') {
            exhibitorEvents = exhibitorEventString.split(',');
          }
        } else {
          exhibitorEvents = [exhibitorEventString];
        }

        Pluswerk.MesseNewsroom.variables.eventsToFetch = fairEvents.length + exhibitorEvents.length;
        if (Pluswerk.MesseNewsroom.variables.eventsToFetch === 0) {
          setUpList();
        }

        var languageMapping = {
          'de': 'Deutsch',
          'en': 'English',
          'es': 'Español',
          'fr': 'Français',
          'it': 'Italiano',
          'pt': 'Português',
          'tr': 'Türkçe',
          'fa': 'Farsi',
          'pl': 'Polski',
          'cz': 'Česky',
          'cs': 'Česky',
          'zh': '中文',
          'nl': 'Nederlands',
          'ru': 'Russian',
          'sl': 'Slovenščina'
        };

        fairEvents.forEach(function (fairEventUid) {
          $.ajax({
            url: Pluswerk.MesseNewsroom.variables.urls.baseUrl + Pluswerk.MesseNewsroom.variables.urls.pressreleaseListUrl + fairEventUid + '/',
            dataType: 'json',
            tryCount: 0,
            retryLimit: 1,
            crossDomain: true,
            success: function (result) {
              storeFetchedPressReleases(result, Pluswerk.MesseNewsroom.variables.locale.en.pressrelease);
            },
            error: function (error) {
              this.tryCount++;
              if (this.tryCount <= this.retryLimit) {
                $.ajax(this);
              } else {
                storeFetchedPressReleases(null, Pluswerk.MesseNewsroom.variables.locale.en.pressrelease);
                $newsroom.find('.js-errorNoMKDB').css({display: 'block'});
              }
            },
          });
        });

        exhibitorEvents.forEach(function (fairEventUid) {
          $.ajax({
            url: Pluswerk.MesseNewsroom.variables.urls.baseUrl + Pluswerk.MesseNewsroom.variables.urls.exhibitorNewsListUrl + fairEventUid,
            dataType: 'json',
            tryCount: 0,
            retryLimit: 1,
            crossDomain: true,
            success: function (result) {
              storeFetchedPressReleases(result, Pluswerk.MesseNewsroom.variables.locale.en.exhibitor);
            },
            error: function (error) {
              this.tryCount++;
              if (this.tryCount <= this.retryLimit) {
                $.ajax(this);
              } else {
                storeFetchedPressReleases(null, Pluswerk.MesseNewsroom.variables.locale.en.exhibitor);
                $newsroom.find('.js-errorNoMKDB').css({display: 'block'});
              }
            },
          });
        });

        var eventsResult = [];
        var storeFetchedPressReleases = function (result, newsType) {
          if (result !== null) {
            Array.prototype.forEach.call(result, function (pressrelease) {
              pressrelease.type = newsType;
              eventsResult.push(pressrelease);
            });
            Pluswerk.MesseNewsroom.variables.eventsFetched++;
          } else {
            Pluswerk.MesseNewsroom.variables.eventErrors++;
          }

          if (Pluswerk.MesseNewsroom.variables.eventsFetched === Pluswerk.MesseNewsroom.variables.eventsToFetch) {
            getOutputHtml(eventsResult);
            return;
          }

          if (Pluswerk.MesseNewsroom.variables.eventsFetched + Pluswerk.MesseNewsroom.variables.eventErrors === Pluswerk.MesseNewsroom.variables.eventsToFetch) {
            getOutputHtml(eventsResult);
          }
        };

        var getOutputHtml = function (result) {
          var resultHtml = '';
          var moreText = $newsroom.data('translationDetail') || 'more';

          var detailPageLink = $newsroom.data('detailPage');

          if (result) {
            for (var key in result) {
              if (result.hasOwnProperty(key) && result[key].title) {
                // get news html (per news)
                var categoryString = result[key].type === Pluswerk.MesseNewsroom.variables.locale.en.pressrelease ? $newsroom.data('translationCategory') : $newsroom.data('translationCategoryExhibitorNews');
                resultHtml = resultHtml + getNewsListTemplate(result[key], moreText, categoryString, detailPageLink);
              }
            }
            var $wrapper = $newsroom.find('.js-newsroom-list');

            // append this news to normal list
            $wrapper.append(resultHtml);

            $wrapper.find('.list__item').sort(function (a, b) {
              return +b.dataset.date - +a.dataset.date;
            }).appendTo($wrapper);
          }

          setUpList();
        };

        var getNewsListTemplate = function (newsItem, moreText, categoryString, detailPageLink) {
          var date = new Date(newsItem.releaseDateFrom);
          var dateString = Pluswerk.MesseNewsroom.functions.formatDate(date);
          var categories = {'categories': [categoryString], 'language': getLanguage(newsItem.language)};
          // Generating links with JS was disabled with TYPO3 v10 (and was never a good idea)
          // var detailUrl = detailPageLink + '/' + newsItem.id + '/' + newsItem.language + '/'
          var detailUrl = detailPageLink
              + '#/' + newsItem.language + '/'
              + Pluswerk.MesseNewsroom.functions.getLocalizedLabel(newsItem.type, newsItem.language) + '/'
              + makeStringUrlConform(newsItem.title) + '-' + newsItem.id;
          var mainImageString = '';

          if (newsItem.mainImage && newsItem.mainImage !== '') {
            var imageSource = newsItem.mainImage;
            if (typeof newsItem.mainImage.src === 'string') {
              imageSource = newsItem.mainImage.src;
            }
            mainImageString = '<a rel="noopener noreferrer" href="' + detailUrl + '" title="' + newsItem.title + '" ' +
                  'class="list__itemImageWrapper"><img src="' + imageSource + '" alt="' + newsItem.title + '" loading="lazy"/></a>';
          }

          var langAttribute = '';
          if (newsItem.language !== document.querySelector('html').lang) {
            langAttribute = ' lang="' + newsItem.language + '"';
          }

          return '<li class="list__item list__item--hide"' + ' data-filter=\'' + JSON.stringify(categories) + '\' data-date="' + date.getTime() / 1000 + '">' +
              mainImageString +
              '<div class="list__itemTeaserWrapper">' +
              '<div class="newsInfo">' +
              '<span class="newsInfo__date">' + dateString + '</span>&nbsp;|&nbsp;' +
              '<span class="newsInfo__type js-newsinfo-type"></span>' +
              '</div>' +
              '<div ' + langAttribute + '>' +
              '<a class="newsInfo__link" title="' + newsItem.title + '" href="' + detailUrl + '">' +
              '<p class="list__itemHeadline h3">' + newsItem.title + '</p>' +
              '</a>' +
              '<p class="list__itemText">' + newsItem.subtitle + '</p>' +
              '</div>' +
              '<a class="list__itemLink" title="' + newsItem.title + '" href="' + detailUrl + '">' + moreText + '</a>' +
              '</div>' +
              '</li>';
        };

        function makeStringUrlConform(str) {
          var clearString = str.toString().toLowerCase();

          // replace special chars
          clearString = clearString.split(/\&+/).join('+')
            .split(/\ö+/).join('oe')
            .split(/\ä+/).join('ae')
            .split(/\ü+/).join('ue')
            .split(/\ß+/).join('ss');

          // remove invalid characters and duplicates
          clearString = clearString.split(/[^a-z0-9]/).join('-').split(/-+/).join('-');
          return clearString.trim('-');
        }

        var getLanguage = function (key) {
          return languageMapping[key];
        };
      } else {
        setUpList();
      }

      $newsroom.find('.spinner').addClass('hide');
      $newsroom.find('.js-newsroom-list .list__item--hide').removeClass('list__item--hide');
      $newsroom.find('.js-pagination').removeClass('hide').css({display: 'flex'});
    },
    NewsDetailsController: function ($newsroomDetails) {
      var mkdbUrl = $newsroomDetails.data('mkdb-url');
      if (typeof mkdbUrl !== 'undefined' && mkdbUrl !== '') {
        Pluswerk.MesseNewsroom.variables.urls.baseUrl = mkdbUrl;
      }
      var hash = window.location.hash;
      var id = '';
      var languageType = '';
      var languageIso = '';
      var type = '';
      if (hash) {
        id = hash.substring(hash.lastIndexOf('-') + 1, hash.length);
        languageType = hash.substring(hash.lastIndexOf('#/') + 2, hash.lastIndexOf('/'));
        languageIso = languageType.substring(0, languageType.lastIndexOf('/'))
        type = languageType.substring(languageType.lastIndexOf('/') + 1);
      }

      if (id !== '' && languageIso !== '') {
        var detailUrl = Pluswerk.MesseNewsroom.variables.urls.baseUrl + Pluswerk.MesseNewsroom.variables.urls.pressreleaseDetailUrl;

        if (type === Pluswerk.MesseNewsroom.functions.getLocalizedLabel('exhibitor', languageIso)) {
          detailUrl = Pluswerk.MesseNewsroom.variables.urls.baseUrl + Pluswerk.MesseNewsroom.variables.urls.exhibitorNewsDetailUrl;
        }

        $.ajax({
          url: detailUrl + id + '/' + languageIso,
          dataType: 'json',
          tryCount: 0,
          retryLimit: 1,
          crossDomain: true,
          success: function (result) {
            getNewsDetailTemplate(result, type, languageIso);

            // hide spinner after loading news
            $newsroomDetails.find('.spinner').addClass('hide');
          },
          error: function (error) {
            this.tryCount++;
            if (this.tryCount <= this.retryLimit) {
              $.ajax(this);
            } else {
              console.error('ajax error: ', error);
              $newsroom.find('.js-errorNoMKDB').css({display: 'block'});

              // hide spinner after loading news
              $newsroomDetails.find('.spinner').addClass('hide');
            }
          },
        });
      }

      var getNewsDetailTemplate = function (newsItem, type, languageIso) {
        var date = new Date(newsItem.releaseDateFrom);
        var dateString = Pluswerk.MesseNewsroom.functions.formatDate(date);
        var backLink = $newsroomDetails.data('backUrl') || '';
        var backLinkText = $newsroomDetails.data('backText') || 'back';
        var captionsDataAttrName = 'captionsText' + languageIso[0].toUpperCase() + languageIso.slice(1);
        var captionsDataAttrNameFallback = 'captionsTextDe';
        var captionsText = $newsroomDetails.data(captionsDataAttrName) || $newsroomDetails.data(captionsDataAttrNameFallback);
        var imageCreditsText = $newsroomDetails.data('imageCreditsText') || 'Image credits';
        if (date.getHours() !== 0 && date.getMinutes() !== 0) {
          dateString = dateString + ' - ' + date.getHours() + ':' + date.getMinutes();
        }
        var zipText = $newsroomDetails.data('zipText') || '';
        var attachmentText = $newsroomDetails.data('attachmentText') || '';
        var imageGalleryString = '';
        var pageImageString = '';
        var imagesCaptionsString = '';
        var downloadZip = '';
        var imageDescription = '';
        var breadCrumbItem = '<li class="breadcrumbNavigation__item breadcrumbNavigation__item--current" title="' + newsItem.title + '">' +
          '<i class="icon icon-double-arrow-right"></i>' + newsItem.title + ' </li>';
        $('.js-breadcrumbNavigation').append(breadCrumbItem);

        //set meta tags
        document.querySelector('meta[property="og:title"]').setAttribute('content', newsItem.socialMedia.ogTitle ? newsItem.socialMedia.ogTitle : newsItem.title);
        document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
        if (document.querySelector('meta[property="og:description"]')) {
          document.querySelector('meta[property="og:description"]').setAttribute('content', newsItem.socialMedia.ogDescription ? newsItem.socialMedia.ogDescription : newsItem.subtitle);
        } else {
          var meta  = document.createElement('meta');
          meta.name   = 'og:description';
          meta.content = newsItem.socialMedia.ogDescription ? newsItem.socialMedia.ogDescription : newsItem.subtitle;
          $('head').append(meta);
        }
        if (document.querySelector('meta[name="twitter:description"]')) {
          document.querySelector('meta[name="twitter:description"]').setAttribute('content', newsItem.socialMedia.twitterDescription ? newsItem.socialMedia.twitterDescription : newsItem.subtitle);
        } else {
          var meta  = document.createElement('meta');
          meta.name   = 'twitter:description';
          meta.content = newsItem.socialMedia.twitterDescription ? newsItem.socialMedia.twitterDescription : newsItem.subtitle;
          $('head').append(meta);
        }

        if (document.querySelector('meta[name="twitter:title"]')) {
          document.querySelector('meta[name="twitter:title"]').setAttribute('content', newsItem.socialMedia.twitterTitle ? newsItem.socialMedia.twitterTitle : newsItem.title);
        } else {
          var meta  = document.createElement('meta');
          meta.name   = 'twitter:title';
          meta.content =  newsItem.socialMedia.twitterTitle ? newsItem.socialMedia.twitterTitle : newsItem.title;
          $('head').append(meta);
        }
        if (newsItem.socialMedia.ogImage || newsItem.mainImage) {
          if (document.querySelector('meta[property="og:image"]')) {
            document.querySelector('meta[property="og:image"]').setAttribute('content', newsItem.socialMedia.ogImage ? newsItem.socialMedia.ogImage : newsItem.mainImage.originalSrc);
          } else {
            var meta  = document.createElement('meta');
            meta.name   = 'og:image';
            meta.content =  newsItem.socialMedia.ogImage ? newsItem.socialMedia.ogImage : newsItem.mainImage.originalSrc;
            $('head').append(meta);
          }
        }
        if (newsItem.socialMedia.twitterImag || newsItem.mainImage) {
          if (document.querySelector('meta[name="twitter:image"]')) {
            document.querySelector('meta[property="twitter:image"]').setAttribute('content', newsItem.socialMedia.twitterImage ? newsItem.socialMedia.twitterImage : newsItem.mainImage.originalSrc);
          } else {
            var meta  = document.createElement('meta');
            meta.name   = 'twitter:image';
            meta.content =  newsItem.socialMedia.twitterImage ? newsItem.socialMedia.twitterImage : newsItem.mainImage.originalSrc
            $('head').append(meta);
          }
        }

        if (newsItem.mainImage) {
          imageDescription = newsItem.mainImage.metadata.subtitle ? newsItem.mainImage.metadata.subtitle : newsItem.mainImage.metadata.cavok_description;
          pageImageString = '<div class="newsDetail__imageWrapper"><a href="' + newsItem.mainImage.originalSrc + '" data-fancybox="mainImage" data-caption="' + imageDescription + '"><img src="' + newsItem.mainImage.src + '" title="' + imageDescription + '" alt="' + imageDescription + '" loading="lazy"/></a></div>';
        } else if (newsItem.images && newsItem.images[0]) {
          imageDescription = newsItem.images[0].metadata.subtitle ? newsItem.images[0].metadata.subtitle : newsItem.images[0].metadata.cavok_description;
          // @todo: temporal workaround for missing "mainImage"
          pageImageString = '<div class="newsDetail__imageWrapper"><a href="' + newsItem.images[0].originalSrc + '" data-fancybox="mainImage" data-caption="' + imageDescription + '"><img src="' + newsItem.images[0].src + '" title="' + imageDescription + '" alt="' + imageDescription + '" loading="lazy"/></a></div>';
        }

        if (newsItem.images) {
          newsItem.images.forEach(function (image) {
            imageDescription = image.metadata.subtitle ? image.metadata.subtitle : image.metadata.cavok_description;
            imageGalleryString = imageGalleryString +
              '<a href="' + image.originalSrc + '" data-fancybox="images" data-caption="' + imageDescription + '" data-loop="true">' +
              '<img style="display:inline; margin-right:10px; max-height: 150px;" height="150" src="' + image.src + '" title="' + imageDescription + '" alt="' + imageDescription + '" loading="lazy">' +
              '</a>';
          });
        } else if (newsItem.mainImage && typeof newsItem.mainImage === 'string') {
          imageDescription = newsItem.mainImage.metadata.subtitle ? newsItem.mainImage.metadata.subtitle : newsItem.mainImage.metadata.cavok_description;
          imageGalleryString = imageGalleryString +
              '<a href="' + newsItem.mainImage + '" data-fancybox="images" data-caption="' + imageDescription + '">' +
              '<img style="display:inline; margin-right:10px; max-height: 150px;" height="150" src="' + newsItem.mainImage + '" title="' + imageDescription + '" alt="' + imageDescription + '" loading="lazy">' +
              '</a>';
        }

        if (newsItem.images && newsItem.images[0]) {
          imagesCaptionsString = '<p><strong>' + captionsText + ':</strong></p>';
          newsItem.images.forEach(function (i) {
            var imgDescription = i.metadata.subtitle ? i.metadata.subtitle : i.metadata.cavok_description;
            imagesCaptionsString += '<p>' + i.filename + ': ' + imgDescription + ' | ' + imageCreditsText + ': ' + i.metadata.cavok_copyright + '</p>';
          });
          imagesCaptionsString += '<p></p><p></p>';
        }

        if (newsItem.additionalAttachments) {
          downloadZip = '<a href="' + newsItem.additionalAttachments + '" class="downloadZip downloadZip--attachment icon-external-link clr">' + attachmentText + '</a>';
        }

        var imagesArchive = '';

        if (newsItem.imagesArchive) {
          imagesArchive = '<a href="' + newsItem.imagesArchive + '" class="downloadZip icon-external-link clr">' + zipText + '</a>';
        }

        var newsContent = '';
        var contentString = '';

        if (type === Pluswerk.MesseNewsroom.functions.getLocalizedLabel('pressrelease', languageIso)) {
          contentString = newsItem.pressReleaseText;
        } else {
          contentString = newsItem.content;
        }

        var langAttribute = '';
        if (languageIso !== document.querySelector('html').lang) {
          langAttribute = ' lang="' + languageIso + '"';
        }

        newsContent = '<div class="newsDetail">' +
          '<div ' + langAttribute + '>' +
          '<span class="newsDetail__date">' + dateString + '</span>' +
          '<h1 class="pageHeadline">' + newsItem.title + '</h1>' +
          '</div>' +
          '<div class="newsDetail__content clr">' +
          '<div ' + langAttribute + '>' +
          pageImageString +
          '<p class="newsDetail__teaser">' + newsItem.subtitle + '</p>' +
          '<p>' + contentString + '</p>' +
            imagesCaptionsString +
            downloadZip +
          '</div>' +
          '<div class="newsDetail__imageSlider">' + imageGalleryString + imagesArchive + '</div>' +
          '<a class="js-back backLink" href="' + backLink + '"><i class="icon icon-arrow-left"></i>' + backLinkText + '</a>' +
          '</div></div>';

        $('.js-newsroomDetails').append(newsContent);
      };
    },
  },
};
